import styled from "styled-components";

export const InputGroupContainer = styled.div`
  font-family: "Segoe UI", sans-serif;
  /* margin: 1em 0 1em 0; */
  width: "auto";
  position: relative;
`;

export const Input = styled.input`
  font-size: 14px;
  padding: 0.8em;
  padding-left: 1.2rem;
  outline: none;
  border: 2px solid rgb(200, 200, 200);
  background-color: transparent;
  border-radius: 7px;
  width: 91.5%;
  height: 20px;
  transition: border-color 0.3s ease;

  &:focus,
  &:valid {
    border-color: rgb(0, 0, 0);
  }
`;

export const Label = styled.label`
  font-size: 15px;
  position: absolute;
  left: 0;
  padding-left: 1.3rem;
  padding-top: 0.8rem;
  pointer-events: none;
  transition: transform 0.3s ease, margin 0.3s ease, padding 0.3s ease,
    background-color 0.3s ease;
  color: rgb(100, 100, 100);

  ${Input}:focus + & {
    transform: translateY(-50%) scale(0.9);
    margin: 0em;
    margin-left: 0.3em;
    padding: 0.4em;
    background-color: #ffffff;
    color: black;
  }
`;

